import React from 'react';
import styled from 'styled-components';
import { panel } from './panelTheme';

export type PropertiesPanelSegmentedOption = {
    value: string;
    label: React.ReactNode;
};

export type PropertiesPanelSegmentedPropertyProps = {
    options: PropertiesPanelSegmentedOption[];
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    ariaLabel?: string;
};

// DUE NOMI AFFIANCATI, NON UN INTERRUTTORE.
//
// Un interruttore mostra un nome solo — acceso o spento — e lascia l'altro implicito nello
// spento: va bene quando una cosa si accende, non quando si SCEGLIE fra due. Qui nessuna delle
// due voci è la negazione dell'altra — sono due modi di consegnare la stessa cosa — e vederle
// accanto è ciò che rende il passaggio immediato invece che da indovinare.
//
// STA NELLA TESTATA DELLA CARD e non fra le righe, per la stessa ragione per cui ci sta
// l'interruttore di una famiglia: non è un parametro fra i parametri, cambia la FORMA di ciò che
// c'è sotto. La differenza con quell'interruttore è che questo non accende niente.
const Group = styled.div<{ $disabled?: boolean }>`
    display: inline-flex;
    flex: none;
    padding: 2px;
    gap: 2px;
    border-radius: 999px;
    background: ${panel.field};
    opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
`;

const Option = styled.button<{ $active: boolean }>`
    appearance: none;
    border: none;
    cursor: pointer;
    height: 20px;
    padding: 0 10px;
    border-radius: 999px;
    font: inherit;
    font-size: 11px;
    font-weight: 500;
    white-space: nowrap;
    background: ${(props) => (props.$active ? panel.surface : 'transparent')};
    color: ${(props) => (props.$active ? panel.ink : panel.inkMuted)};
    box-shadow: ${(props) => (props.$active ? `0 0 0 1px ${panel.line}` : 'none')};

    &:disabled {
        cursor: default;
    }
`;

export const PropertiesPanelSegmented: React.FC<PropertiesPanelSegmentedPropertyProps> = ({ options, value, onChange, disabled, ariaLabel }) => (
    <Group role='radiogroup' aria-label={ariaLabel} $disabled={disabled}>
        {options.map((option) => (
            <Option
                key={option.value}
                type='button'
                role='radio'
                aria-checked={option.value === value}
                $active={option.value === value}
                disabled={disabled}
                onClick={() => option.value !== value && onChange(option.value)}
            >
                {option.label}
            </Option>
        ))}
    </Group>
);
